module.exports = __webpack_public_path__ + "img/Memories.a4edc31a.jpg";